'use client'

import { datadogRum } from '@datadog/browser-rum'
import isProductionEnv from '@lib/utilities/isProductionEnv'

// Datadog appId and clientToken are public
const appId = '77b79831-e3ea-443a-8a4c-7a9614c41d77'
const clientToken = 'pub7b84c52da8e5064c4a47aa9c4a1fc332'

datadogRum.init({
  // Specify URLs to propagate trace headers for connection between RUM and backend trace
  allowedTracingUrls: [
    {
      match: 'https://www.withpower.com/api/',
      propagatorTypes: ['tracecontext'],
    },
  ],
  applicationId: appId,
  clientToken,
  defaultPrivacyLevel: 'mask-user-input',
  env: isProductionEnv() ? 'production' : 'preview',
  service: 'www-withpower-com-app',
  sessionReplaySampleRate: 10,
  sessionSampleRate: 100,
  site: 'datadoghq.com',
  trackLongTasks: true,
  trackResources: true,
  trackUserInteractions: true,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: process.env.FC_GIT_COMMIT_SHA,
})

/** @see https://docs.datadoghq.com/real_user_monitoring/guide/monitor-your-nextjs-app-with-rum/?tab=npm */
export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null
}
